const state = () => ({
  //===================== remoteId
  remoteId : null,
  //===================== 원격진단
  result: null,
  bdInfo: null,
  dmInfo: null,
  
  //--------------------- ECU테스트
  runup: null, // ECU런업테스트 결과
  shutoff: null, // ECU셧오프테스트 결과
  compres: null, // ECU컴프레션테스트 결과
  highpre: null, // ECU하이프레쥬테스트 결과

  //--------------------- DCU테스트
  lqsLevel: null, // DCU LQS레벨시험
  lqsTemp: null, // DCU LQS온도시험
  prvTest: null, // DCU prv시험
  leakTest: null, // DCU 시스템누수시험
  defInjectTest: null, // DCU 요소수인젝터분무시험
  defControlTest: null, // DCU 요소수컨트롤러히터시험
  defHeaterTest: null, // DCU 요소수라인히터시험 
  
  //--------------------- ECU입출력테스트
  acvTest: null,
  egrTest: null,
  plugTest: null,
  hpTest: null,
  buzzTest: null,

  //===================== 애프터서비스
  c3iInfo: null,
  partReplacement: null, // ECU교체

  //===================== 에러
  errorMsg : null,

  //===================== 리프로그램
  reprogramMsg : null,

  //===================== 시동 꺼짐
  accOff : null,
  remoteWatchInfo : null,

  //===================== 리프로그램 RPM 제한
  tripRpm : null, // null = TRIP 미수신 — 수신 전에는 APPLY 차단 유지 (fail-safe, DDAT-1219)
  //===================== INIT TOPIC RPM (시동 ON / KEY ON 판단용) — DDAT-1209
  initRpm : null,
});

const getters = {
  getResult: (state) => state.result,
  getBdInfo: (state) => state.bdInfo,
  getDmInfo: (state) => state.dmInfo,
  getRunup: (state) => state.runup,
  getShutoff: (state) => state.shutoff,
  getCompres: (state) => state.compres,
  getHighpre: (state) => state.highpre,
  getLqsLevel: (state) => state.lqsLevel,
  getLqsTemp: (state) => state.lqsTemp,
  getPrvTest: (state) => state.prvTest,
  getLeakTest: (state) => state.leakTest,
  getDefInjectTest: (state) => state.defInjectTest,
  getDefControlTest: (state) => state.defControlTest,
  getDefHeaterTest: (state) => state.defHeaterTest,
  getACVTest: state => state.acvTest,
  getEGRTest: state => state.egrTest,
  getPlugTest: state => state.plugTest,
  getHPTest: state => state.hpTest,
  getBuzzTest: state => state.buzzTest,
  
  getEcuChange: state => state.ecuChange,

  getC3iInfo: (state) => state.c3iInfo,
  getPartReplacement: (state) => state.partReplacement,
  getErrorMsg: (state) => state.errorMsg,

  getReprogramMsg : (state) => state.reprogramMsg,
  getRemoteId : state => state.remoteId,
  getAccOff : state => state.accOff,
  getRemoteWatchInfo : state => state.remoteWatchInfo,
  getTripRpm : state => state.tripRpm,
  getInitRpm : state => state.initRpm,
};

const actions = {
  //===================== 원격진단
  setResult({ commit }, result) {
    commit('SET_RESULT', result);
  },  
  clearResult({ commit }) {
    commit('CLEAR_RESULT');
  },

  setBdInfo({ commit }, result) {
    commit('SET_BDINFO', result);
  },
  clearBdInfo({ commit }) {
    commit('CLEAR_BDINFO');
  },

  setDmInfo({ commit }, result) {
    commit('SET_DMINFO', result);
  },
  clearDmInfo({ commit }) {
    commit('CLEAR_DMINFO');
  },
  // ================ 원격진단 ECU테스트
  setRunup({ commit }, result) {
    commit('SET_RUNUP', result);
  },
  clearRunup({ commit }) {
    commit('CLEAR_RUNUP');
  },

  setShutoff({ commit }, result) {
    commit('SET_SHUTOFF', result);
  },
  clearShutoff({ commit }) {
    commit('CLEAR_SHUTOFF');
  },

  setCompres({ commit }, result) {
    commit('SET_COMPRES', result);
  },
  clearCompres({ commit }) {
    commit('CLEAR_COMPRES');
  },

  setHighpre({ commit }, result) {
    commit('SET_HIGHPRE', result);
  },
  clearHighpre({ commit }) {
    commit('CLEAR_HIGHPRE');
  },
  // ================ 원격진단 DCU테스트
  setLqsLevel({ commit }, result){
    commit('SET_LQSLEVEL', result);
  },
  clearLqsLevel({ commit }) {
    commit('CLEAR_LQSLEVEL');
  },

  setLqsTemp({ commit }, result){
    commit('SET_LQSTEMP', result);
  },
  clearLqsTemp({ commit }) {
    commit('CLEAR_LQSTEMP');
  },

  setPrvTest({ commit }, result) {
    commit('SET_PRVTEST', result);
  },
  clearPrvTest({ commit }) {
    commit('CLEAR_PRVTEST');
  },

  setLeakTest({ commit }, result) {
    commit('SET_LEAKTEST', result);
  },
  clearLeakTest({ commit }) {
    commit('CLEAR_LEAKTEST');
  },

  setDefInjectTest({ commit }, result) {
    commit('SET_DEF_INJECT_TEST', result);
  },
  clearDefInjectTest({ commit }) {
    commit('CLEAR_DEF_INJECT_TEST');
  },

  setDefControlTest({ commit }, result) {
    commit('SET_DEF_CONTROL_TEST', result);
  },
  clearDefControlTest({ commit }) {
    commit('CLEAR_DEF_CONTROL_TEST');
  },
  setDefHeaterTest({ commit }, result) {
    commit('SET_DEF_HEATER_TEST', result);
  },
  clearDefHeaterTest({ commit }) {
    commit('CLEAR_DEF_HEATER_TEST');
  },
  // ================ 원격진단 ECU입출력테스트
  setACVTest({ commit }, result) {
    commit('SET_ACV_TEST', result);
  },
  clearACVTest({ commit }) {
    commit('CLEAR_ACV_TEST');
  },
  setEGRTest({ commit }, result) {
    commit('SET_EGR_TEST', result);
  },
  clearEGRTest({ commit }) {
    commit('CLEAR_EGR_TEST');
  },
  setPlugTest({ commit }, result) {
    commit('SET_PLUG_TEST', result);
  },
  clearPlugTest({ commit }) {
    commit('CLEAR_PLUG_TEST');
  },
  setBuzzTest({ commit }, result) {
    commit('SET_BUZZ_TEST', result);
  },
  clearBuzzTest({ commit }) {
    commit('CLEAR_BUZZ_TEST');
  },
  setHPTest({ commit }, result) {
    commit('SET_HP_TEST', result);
  },
  clearHPTest({ commit }) {
    commit('CLEAR_HP_TEST');
  },
  
  clearIotResult({ commit }) { //IotResult내용 다 삭제
    commit('CLEAR_IOTRESULT');
  },
  
  //===================== 애프터서비스
  setC3iInfo({ commit }, result) {
    commit('SET_C3I_INFO', result);
  },
  clearC3iInfo({ commit }) {
    commit('CLEAR_C3I_INFO');
  },
  setPartReplacement({ commit }, result) {
    commit('SET_PART_PLACEMENT', result);
  },
  clearPartReplacement({ commit }) {
    commit('CLEAR_PART_PLACEMENT');
  },
  setErrorMsg({ commit }, result) {
    commit('SET_ERROR_MSG', result);
  },
  clearErrorMsg({ commit }) {
    commit('CLEAR_ERROR_MSG');
  },
  setReprogramMsg({ commit }, result) {
    commit('SET_REPROGRAM_MSG', result);
  },
  clearReprogramMsg({ commit }) {
    commit('CLEAR_REPROGRAM_MSG');
  },
  setRemoteId({ commit }, result) {
    commit('SET_REMOTE_ID', result);
  },
  clearRemoteId({ commit }) {
    commit('CLEAR_REMOTE_ID');
  },

  // ================ 시동 꺼짐
  setAccOff({ commit }, result) {
    commit('SET_ACC_OFF', result);
  },
  clearAccOff({ commit }) {
    commit('CLEAR_ACC_OFF');
  },
  setRemoteWatchInfo({ commit }, result) {
    commit('SET_REMOTE_WATCH_INFO', result);
  },
  clearRremoteWatchInfo({ commit }) {
    commit('CLEAR_REMOTE_WATCH_INFO');
  },

  setTripRpm({ commit }, result) {
    commit('SET_TRIP_RPM', result);
  },
  clearTripRpm({ commit }) {
    commit('CLEAR_TRIP_RPM');
  },
  setInitRpm({ commit }, rpm) {
    commit('SET_INIT_RPM', rpm);
  },
  clearInitRpm({ commit }) {
    commit('CLEAR_INIT_RPM');
  },

};

const mutations = {
  //===================== 원격진단
  SET_RESULT(state, result) {
    state.result = result;
  },
  CLEAR_RESULT(state) {
    state.result = null;
  },

  SET_BDINFO(state, result) {
    state.bdInfo = result;
  },
  CLEAR_BDINFO(state) {
    state.bdInfo = null;
  },

  SET_DMINFO(state, result) {
    state.dmInfo = result;
  },
  CLEAR_DMINFO(state) {
    state.dmInfo = null;
  },

  SET_RUNUP(state, result) {
    state.runup = result;
  },
  CLEAR_RUNUP(state) {
    state.runup = null;
  },

  SET_SHUTOFF(state, result) {
    state.shutoff = result;
  },
  CLEAR_SHUTOFF(state) {
    state.shutoff = null;
  },

  SET_COMPRES(state, result) {
    state.compres = result;
  },
  CLEAR_COMPRES(state) {
    state.compres = null;
  },

  SET_HIGHPRE(state, result) {
    state.highpre = result;
  },
  CLEAR_HIGHPRE(state) {
    state.highpre = null;
  },

  SET_LQSLEVEL(state, result) {
    state.lqsLevel = result;
  },
  CLEAR_LQSLEVEL(state) {
    state.lqsLevel = null;
  },

  SET_LQSTEMP(state, result) {
    state.lqsTemp = result;
  },
  CLEAR_LQSTEMP (state) {
    state.lqsTemp = null;
  },

  SET_PRVTEST(state, result) {
    state.prvTest = result;
  },
  CLEAR_PRVTEST (state) {
    state.prvTest = null;
  },

  SET_LEAKTEST(state, result) {
    state.leakTest = result;
  },
  CLEAR_LEAKTEST (state) {
    state.leakTest = null;
  },

  SET_ACV_TEST(state, result) {
    state.acvTest = result;
  },
  CLEAR_ACV_TEST(state) {
    state.acvTest = null;
  },
  SET_EGR_TEST(state, result) {
    state.egrTest = result;
  },
  CLEAR_EGR_TEST(state) {
    state.egrTest = null;
  },
  SET_PLUG_TEST(state, result) {
    state.plugTest = result;
  },
  CLEAR_PLUG_TEST(state) {
    state.plugTest = null;
  },
  SET_HP_TEST(state, result) {
    state.hpTest = result;
  },
  CLEAR_HP_TEST(state) {
    state.hpTest = null;
  },
  SET_BUZZ_TEST(state, result) {
    state.buzzTest = result;
  },
  CLEAR_BUZZ_TEST(state) {
    state.buzzTest = null;
  },

  SET_DEF_INJECT_TEST(state, result) {
    state.defInjectTest = result;
  },
  CLEAR_DEF_INJECT_TEST(state) {
    state.defInjectTest = null;
  },

  SET_DEF_CONTROL_TEST(state, result) {
    state.defControlTest = result;
  },
  CLEAR_DEF_CONTROL_TEST(state) {
    state.defControlTest = null;
  },

  SET_DEF_HEATER_TEST(state, result) {
    state.defHeaterTest = result;
  },
  CLEAR_DEF_HEATER_TEST(state) {
    state.defHeaterTest = null;
  },

  //===================== 애프터서비스
  
  SET_C3I_INFO(state, result) {
    state.c3iInfo = result;
  },
  CLEAR_C3I_INFO(state) {
    state.c3iInfo = null;
  },
  SET_PART_PLACEMENT(state, result) {
    state.partReplacement = result;
  },
  CLEAR_PART_PLACEMENT(state) {
    state.partReplacement = null;
  },
  SET_ERROR_MSG(state, result) {
    state.errorMsg = result;
  },
  CLEAR_ERROR_MSG(state) {
    state.errorMsg = null;
  },
  SET_REPROGRAM_MSG(state, result) {
    state.reprogramMsg = result;
  },
  CLEAR_REPROGRAM_MSG(state) {
    state.reprogramMsg = null;
  },
  SET_REMOTE_ID(state, result) {
    state.remoteId = result;
  },
  CLEAR_REMOTE_ID(state) {
    state.remoteId = null;
  },
  // =============== 시동 꺼짐
  SET_ACC_OFF(state, result) {
    state.accOff = result;
  },
  CLEAR_ACC_OFF(state) {
    state.accOff = null;
  },
  SET_REMOTE_WATCH_INFO(state, result) {
    state.remoteWatchInfo = result;
  },
  CLEAR_REMOTE_WATCH_INFO(state) {
    state.remoteWatchInfo = null;
  },
  SET_TRIP_RPM(state, result) {
    state.tripRpm = result;
  },
  CLEAR_TRIP_RPM(state) {
    state.tripRpm = null;
  },
  SET_INIT_RPM(state, rpm) {
    state.initRpm = rpm;
  },
  CLEAR_INIT_RPM(state) {
    state.initRpm = null;
  },
  CLEAR_IOTRESULT(state) {
    state.result = null;
    state.bdInfo = null;
    state.dmInfo = null;
    state.runup = null;
    state.shutoff = null;
    state.compres = null;
    state.highpre = null;
    state.lqsLevel = null;
    state.lqsTemp = null;
    state.prvTest = null;
    state.leakTest = null;
    state.defInjectTest = null;
    state.defControlTest = null;
    state.defHeaterTest = null;
    state.acvTest = null;
    state.egrTest = null;
    state.plugTest = null;
    state.hpTest = null;
    state.buzzTest = null;
    state.c3iInfo = null;
    state.partReplacement = null;
    state.errorMsg = null;
    state.reprogramMsg = null;
    state.remoteId = null;
    state.accOff = null;
    state.remoteWatchInfo = null;
    state.tripRpm = null;
  },
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
